import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useQuery } from '@apollo/client';
import { CloseIcon, CopyIcon } from '@chakra-ui/icons';
import { Avatar, Box, Flex, HStack, IconButton, Menu, MenuButton, MenuItem, MenuList, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverTrigger, Portal, Skeleton, Stack, Text, Textarea, useDisclosure } from '@chakra-ui/react';
import { services } from '@cofit/api';
import { Button } from '@cofit/components';
import { ChatroomsDatabase } from '@cofit/worker';
import { IoLanguageSharp } from '@react-icons/all-files/io5/IoLanguageSharp';
import { useLiveQuery } from 'dexie-react-hooks';
import moment from 'moment';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import * as R from 'ramda';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { AutoSizer } from 'react-virtualized';
import { useChatSharedWorkerProvider } from 'src/context/ChatSharedWorkerProvider';
import { useSideBarContext } from 'src/context/SideBarContextProvider';
import { htmlToPlainText } from 'src/utils/html';
import { useCopyToClipboard, useLocalStorage } from 'usehooks-ts';
import { ReferralCodesQueryGQL } from '../../api/ReferralCodesApi';
import { BranchConstants, LOCALE_LOCAL_STORAGE_KEY, commonSettings, isCofit } from '../../constants';
import dataTestID from '../../constants/DataTestIndex';
import { useUserDataContextProvider } from '../../context/UserDataContextProvider';
import BranchSelector from '../BranchSelector';
import { NotificationMenuWithTriggerButton } from '../NotificationMenuWithTriggerButton';
import { SendIcon } from '../common/Icons';
import TitleHeader from '../common/TitleHeader';
import { SearchBar } from './SearchBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var db = new ChatroomsDatabase();

var CofitGPT = function CofitGPT(_ref) {
  var id = _ref.id,
      h = _ref.h;

  var _useCopyToClipboard = useCopyToClipboard(),
      _useCopyToClipboard2 = _slicedToArray(_useCopyToClipboard, 2),
      copy = _useCopyToClipboard2[1];

  var bottomRef = useRef(null);
  var suggestions = useLiveQuery(function () {
    return db.getSuggestions(id);
  }, [id]);
  var scrollToBottom = useCallback(function () {
    var _bottomRef$current;

    (_bottomRef$current = bottomRef.current) === null || _bottomRef$current === void 0 ? void 0 : _bottomRef$current.scrollIntoView({
      behavior: 'smooth'
    });
  }, []);
  useEffect(function () {
    scrollToBottom();
  }, [suggestions, scrollToBottom]);
  var handleCopyButtonClicked = useCallback(function (text) {
    return function () {
      copy(text);
    };
  }, [copy]);
  return /*#__PURE__*/_jsxs(Stack, {
    h: h,
    spacing: "4",
    overflow: "auto",
    e2eid: "Header_index_Stack",
    children: [suggestions === null || suggestions === void 0 ? void 0 : suggestions.map(function (suggestion, i) {
      return /*#__PURE__*/_jsxs(Stack, {
        p: "4",
        e2eid: "Header_index_Stack_1",
        children: [/*#__PURE__*/_jsx(Box, {
          rounded: "3xl",
          py: "2",
          px: "5",
          bg: "gray.600",
          alignSelf: "flex-end",
          e2eid: "Header_index_Box",
          children: /*#__PURE__*/_jsx(Text, {
            color: "white",
            e2eid: "Header_index_Text",
            children: suggestion.text
          })
        }), /*#__PURE__*/_jsxs(Box, {
          e2eid: "Header_index_Box",
          children: [/*#__PURE__*/_jsx(Skeleton, {
            isLoaded: suggestion.isReady,
            minH: "10",
            e2eid: "Header_index_Skeleton",
            children: /*#__PURE__*/_jsx(Text, {
              e2eid: "Header_index_Text",
              children: suggestion.reply
            })
          }), /*#__PURE__*/_jsx(IconButton, {
            size: "xs",
            variant: "ghost",
            colorScheme: "gray",
            icon: /*#__PURE__*/_jsx(CopyIcon, {
              boxSize: "5",
              e2eid: "Header_index_CopyIcon"
            }),
            onClick: handleCopyButtonClicked(suggestion.reply),
            e2eid: "Header_index_IconButton"
          })]
        })]
      }, i);
    }), /*#__PURE__*/_jsx("div", {
      ref: bottomRef,
      e2eid: "Header_index_div"
    })]
  });
};

var CustomPopover = function CustomPopover(_ref2) {
  var trigger = _ref2.trigger,
      onConfirm = _ref2.onConfirm,
      children = _ref2.children;

  var _useDisclosure = useDisclosure(),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Popover, {
    onOpen: onOpen,
    isOpen: isOpen,
    onClose: onClose,
    isLazy: true,
    placement: "top-start",
    autoFocus: false,
    e2eid: "Header_index_Popover",
    children: [/*#__PURE__*/_jsx(PopoverTrigger, {
      e2eid: "Header_index_PopoverTrigger",
      children: trigger
    }), /*#__PURE__*/_jsxs(PopoverContent, {
      border: "none",
      boxShadow: "md",
      w: "2xs",
      e2eid: "Header_index_PopoverContent",
      children: [/*#__PURE__*/_jsx(PopoverArrow, {
        e2eid: "Header_index_PopoverArrow"
      }), /*#__PURE__*/_jsx(PopoverCloseButton, {
        e2eid: "Header_index_PopoverCloseButton"
      }), /*#__PURE__*/_jsxs(PopoverBody, {
        as: Stack,
        spacing: "4",
        p: "4",
        e2eid: "Header_index_PopoverBody",
        children: [children, /*#__PURE__*/_jsxs(HStack, {
          justifyContent: "flex-end",
          e2eid: "Header_index_HStack",
          children: [/*#__PURE__*/_jsx(Button, {
            variant: "ghost",
            colorScheme: "gray",
            onClick: onClose,
            e2eid: "Header_index_Button",
            children: t('common:button.cancel', '取消')
          }), /*#__PURE__*/_jsx(Button, {
            variant: "ghost",
            onClick: function onClick() {
              onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
              onClose();
            },
            isDisabled: !onConfirm,
            e2eid: "Header_index_Button_18",
            children: t('common:button.confirm', '確認')
          })]
        })]
      })]
    })]
  });
};

var AiSuggestionWithTriggerButton = function AiSuggestionWithTriggerButton() {
  var _user$profile;

  var _useDisclosure2 = useDisclosure(),
      isOpen = _useDisclosure2.isOpen,
      onOpen = _useDisclosure2.onOpen,
      onClose = _useDisclosure2.onClose;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  var user = useUserDataContextProvider();
  var id = "User/".concat(user === null || user === void 0 ? void 0 : (_user$profile = user.profile) === null || _user$profile === void 0 ? void 0 : _user$profile.id);

  var _useSideBarContext = useSideBarContext(),
      btnRef = _useSideBarContext.btnRef,
      sideBarContainerRef = _useSideBarContext.sideBarContainerRef;

  var composerRef = useRef(null);
  var userProfile = useMemo(function () {
    return user === null || user === void 0 ? void 0 : user.profile;
  }, [user]);

  var _useChatSharedWorkerP = useChatSharedWorkerProvider(),
      sendMessagesToSocket = _useChatSharedWorkerP.sendMessagesToSocket;

  var handleSendMessage = useCallback(function () {
    if (!composerRef.current) return;
    var content = composerRef.current.value;
    var insertedMessage = services.chat.formatInsertedMessage({
      message: {
        text: htmlToPlainText(content),
        user: services.chat.getMessageUserFromUser(userProfile),
        id: id
      }
    });
    var outgoingMessage = services.chat.formatOutgoingMessage({
      id: id,
      message: insertedMessage
    });
    sendMessagesToSocket(['v1:generate:suggestion', _objectSpread(_objectSpread({}, outgoingMessage), {}, {
      noAutoSend: true
    })]);
    composerRef.current.value = '';
  }, [sendMessagesToSocket, userProfile, id]);
  var handleSubmitEditing = useCallback(function (e) {
    var key = e.key,
        ctrlKey = e.ctrlKey,
        metaKey = e.metaKey,
        nativeEvent = e.nativeEvent;

    if (key === 'Enter' && (ctrlKey || metaKey)) {
      nativeEvent.preventDefault();
      handleSendMessage();
    }
  }, [handleSendMessage]);
  var handleClearChatHistory = useCallback(function () {
    sendMessagesToSocket(['v1:clear:suggestions', {
      chatRoomId: id
    }]);
  }, [id]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      ref: btnRef,
      variant: "ghost",
      colorScheme: "gray",
      onClick: onOpen,
      e2eid: "Header_index_Button_19",
      children: "AI"
    }), /*#__PURE__*/_jsx(Portal, {
      containerRef: sideBarContainerRef,
      e2eid: "Header_index_Portal",
      children: isOpen && /*#__PURE__*/_jsxs(Stack, {
        bg: "white",
        w: "300px",
        h: "full",
        boxShadow: "md",
        e2eid: "Header_index_Stack",
        children: [/*#__PURE__*/_jsxs(HStack, {
          justifyContent: "space-between",
          px: "4",
          py: "2",
          e2eid: "Header_index_HStack",
          children: [/*#__PURE__*/_jsx(TitleHeader, {
            e2eid: "Header_index_TitleHeader",
            children: t('common:askAI', '問問AI')
          }), /*#__PURE__*/_jsx(IconButton, {
            icon: /*#__PURE__*/_jsx(CloseIcon, {
              e2eid: "Header_index_CloseIcon"
            }),
            variant: "ghost",
            size: "sm",
            colorScheme: "gray",
            onClick: onClose,
            e2eid: "Header_index_IconButton"
          })]
        }), /*#__PURE__*/_jsx(Box, {
          flex: "1",
          overflow: "auto",
          e2eid: "Header_index_Box",
          children: /*#__PURE__*/_jsx(AutoSizer, {
            disableWidth: true,
            e2eid: "Header_index_AutoSizer",
            children: function children(_ref3) {
              var height = _ref3.height;
              return /*#__PURE__*/_jsx(CofitGPT, {
                id: id,
                h: height,
                e2eid: "Header_index_CofitGPT"
              });
            }
          })
        }), /*#__PURE__*/_jsxs(Stack, {
          py: "4",
          bg: "#FAFAFA",
          boxShadow: "sm",
          borderTop: "1px",
          borderColor: "gray.200",
          e2eid: "Header_index_Stack",
          children: [/*#__PURE__*/_jsx(HStack, {
            justify: "space-between",
            px: "1",
            e2eid: "Header_index_HStack",
            children: /*#__PURE__*/_jsxs(CustomPopover, {
              trigger: /*#__PURE__*/_jsx(Button, {
                variant: "ghost",
                colorScheme: "gray",
                size: "sm",
                color: "#5E5873",
                e2eid: "Header_index_Button",
                children: t('common:clearChatHistory', '清除聊天記錄')
              }),
              onConfirm: handleClearChatHistory,
              e2eid: "Header_index_CustomPopover",
              children: [/*#__PURE__*/_jsx(TitleHeader, {
                e2eid: "Header_index_TitleHeader",
                children: t('common:clearChatHistory', '清除聊天記錄')
              }), /*#__PURE__*/_jsxs(Text, {
                e2eid: "Header_index_Text",
                children: [t('common:confirmClearChatHistory', '確認清除聊天記錄'), "\uFF1F"]
              })]
            })
          }), /*#__PURE__*/_jsxs(HStack, {
            alignItems: "flex-end",
            pl: "2",
            spacing: "1",
            e2eid: "Header_index_HStack",
            children: [/*#__PURE__*/_jsx(Textarea, {
              ref: composerRef,
              bg: "white",
              placeholder: "\u50B3\u9001\u554F\u984C\u7D66AI...\nCtrl or Cmd +Enter\uFF1A\u50B3\u9001\nEnter\uFF1A\u63DB\u884C",
              onKeyDown: handleSubmitEditing,
              e2eid: "Header_index_Textarea"
            }), /*#__PURE__*/_jsx(IconButton, {
              size: "sm",
              variant: "ghost",
              colorScheme: "gray",
              icon: /*#__PURE__*/_jsx(SendIcon, {
                boxSize: "5",
                e2eid: "Header_index_SendIcon"
              }),
              onClick: handleSendMessage,
              e2eid: "Header_index_IconButton"
            })]
          })]
        })]
      })
    })]
  });
};

export var Header = function Header(_ref4) {
  var _ref4$hasNotification = _ref4.hasNotification,
      hasNotification = _ref4$hasNotification === void 0 ? false : _ref4$hasNotification,
      _ref4$showBannerTitle = _ref4.showBannerTitle,
      showBannerTitle = _ref4$showBannerTitle === void 0 ? true : _ref4$showBannerTitle,
      _ref4$hasAiSuggestion = _ref4.hasAiSuggestion,
      hasAiSuggestion = _ref4$hasAiSuggestion === void 0 ? false : _ref4$hasAiSuggestion;

  var _useTranslation3 = useTranslation(),
      t = _useTranslation3.t;

  var _useLocalStorage = useLocalStorage(LOCALE_LOCAL_STORAGE_KEY, 'zh-TW'),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      setLocale = _useLocalStorage2[1];

  var _useUserDataContextPr = useUserDataContextProvider(),
      profile = _useUserDataContextPr.profile,
      logout = _useUserDataContextPr.logout,
      name = _useUserDataContextPr.name;

  var _useRouter = useRouter(),
      query = _useRouter.query,
      asPath = _useRouter.asPath,
      pathname = _useRouter.pathname,
      push = _useRouter.push;

  var _ref5 = profile || {},
      _ref5$nick_name = _ref5.nick_name,
      nick_name = _ref5$nick_name === void 0 ? '' : _ref5$nick_name,
      _ref5$avatar_thumbnai = _ref5.avatar_thumbnail_url,
      avatar_thumbnail_url = _ref5$avatar_thumbnai === void 0 ? '' : _ref5$avatar_thumbnai,
      id = _ref5.id;

  var _useQuery = useQuery(ReferralCodesQueryGQL, {
    variables: {
      member_id: id,
      member_type: 'User'
    },
    skip: !id
  }),
      referralCodesData = _useQuery.data;

  var handleChangeLocale = useCallback(function (e) {
    var lo = e.target.getAttribute('data-id');
    setLocale(lo);
    push({
      pathname: pathname,
      query: query
    }, asPath, {
      locale: lo
    });
    moment.locale(lo.toLowerCase());
  }, [setLocale, asPath, pathname, push, query]);
  var referralCodes = useMemo(function () {
    return referralCodesData ? R.pipe(R.propOr([], 'referral_codes'), R.map(R.propOr('', 'code')))(referralCodesData) : [];
  }, [referralCodesData]);
  return /*#__PURE__*/_jsxs(HStack, {
    w: "full",
    p: "0",
    e2eid: "Header_index_HStack",
    children: [BranchConstants.ENABLE_SEARCH_USERS && /*#__PURE__*/_jsx(SearchBar, {
      e2eid: "Header_index_SearchBar"
    }), /*#__PURE__*/_jsxs(HStack, {
      flex: "1",
      pos: "relative",
      justify: "flex-end",
      zIndex: "dropdown",
      e2eid: "Header_index_HStack",
      children: [(showBannerTitle || commonSettings.isDevelopmentEnv || commonSettings.isTestingEnv) && /*#__PURE__*/_jsxs(HStack, {
        direction: "column",
        e2eid: "Header_index_HStack_42",
        children: [/*#__PURE__*/_jsxs(Text, {
          color: isCofit() ? '#00B1C9' : 'brand',
          fontWeight: 700,
          fontSize: "20px",
          e2eid: "Header_index_Text",
          children: [commonSettings.BANNER_PREFIX, " ", BranchConstants.BANNER_TITLE]
        }), commonSettings.FEATURES.branchSelector && /*#__PURE__*/_jsx(BranchSelector, {
          e2eid: "Header_index_BranchSelector"
        })]
      }), hasAiSuggestion && /*#__PURE__*/_jsx(AiSuggestionWithTriggerButton, {
        e2eid: "Header_index_AiSuggestionWithTriggerButton"
      }), hasNotification && /*#__PURE__*/_jsx(NotificationMenuWithTriggerButton, {
        e2eid: "Header_index_NotificationMenuWithTriggerButton"
      }), /*#__PURE__*/_jsxs(Menu, {
        variant: "chat",
        placement: "bottom-end",
        offset: [0, 0],
        e2eid: "Header_index_Menu",
        children: [/*#__PURE__*/_jsx(MenuButton, {
          e2eid: "Header_index_MenuButton",
          children: /*#__PURE__*/_jsx(IoLanguageSharp, {
            size: "xs",
            e2eid: "Header_index_IoLanguageSharp"
          })
        }), /*#__PURE__*/_jsxs(MenuList, {
          borderRadius: "md",
          e2eid: "Header_index_MenuList",
          children: [/*#__PURE__*/_jsx(MenuItem, {
            "data-id": "zh-TW",
            onClick: handleChangeLocale,
            e2eid: "Header_index_MenuItem",
            children: t('common:locales.zh-TW', '繁體中文')
          }), /*#__PURE__*/_jsx(MenuItem, {
            "data-id": "zh-CN",
            onClick: handleChangeLocale,
            e2eid: "Header_index_MenuItem_52",
            children: t('common:locales.zh-CN', '简体中文')
          })]
        })]
      }), /*#__PURE__*/_jsx(Flex, {
        direction: "column",
        e2eid: "Header_index_Flex",
        children: /*#__PURE__*/_jsx(Text, {
          "data-test": dataTestID.login.LoginedNickname,
          color: "#6E6B7B",
          fontSize: "14px",
          e2eid: "Header_index_Text",
          children: name || nick_name
        })
      }), /*#__PURE__*/_jsxs(Popover, {
        e2eid: "Header_index_Popover",
        children: [/*#__PURE__*/_jsx(PopoverTrigger, {
          e2eid: "Header_index_PopoverTrigger",
          children: /*#__PURE__*/_jsx(Avatar, {
            "data-test": dataTestID.login.LoginedAvatar,
            cursor: "pointer",
            w: "35px",
            h: "35px",
            src: avatar_thumbnail_url,
            e2eid: "Header_index_Avatar"
          })
        }), /*#__PURE__*/_jsx(PopoverContent, {
          w: "28",
          fontWeight: "bold",
          bgColor: "#35383C",
          e2eid: "Header_index_PopoverContent",
          children: /*#__PURE__*/_jsxs(Stack, {
            w: "full",
            p: "2",
            justifyItems: "center",
            alignItems: "center",
            e2eid: "Header_index_Stack",
            children: [(referralCodes === null || referralCodes === void 0 ? void 0 : referralCodes.length) > 0 && (referralCodes === null || referralCodes === void 0 ? void 0 : referralCodes.map(function (referralCode, idx) {
              return /*#__PURE__*/_jsx(Text, {
                textColor: "gray.300",
                e2eid: "Header_index_Text",
                children: referralCode
              }, idx);
            })), /*#__PURE__*/_jsx(Text, {
              w: "full",
              "data-test": dataTestID.login.LogoutButton,
              cursor: "pointer",
              textColor: "white",
              align: "center",
              onClick: logout,
              e2eid: "Header_index_Text_61",
              children: t("common:button.logout", '登出')
            })]
          })
        })]
      })]
    })]
  });
};